import type { INotification } from '@magicbell/react-headless';

import * as analytics from '@gitbook/app-analytics/client';
import { resolveURLToNavigation } from '@gitbook/app-navigation';

import { useNavigation } from '../../navigation';

/**
 * Return a callback to open a notification.
 */
export function useOpenNotification(): (notification: INotification) => void {
    const { navigate } = useNavigation();

    return (notification) => {
        analytics.logEvent(
            analytics.createNotificationEvent(notification, {
                type: 'notification_open',
            })
        );

        if (notification.actionUrl) {
            const screen = resolveURLToNavigation(notification.actionUrl);
            if (!screen) {
                window.location.href = notification.actionUrl;
            } else {
                navigate({ screen });
            }
        }

        // Mark the notification as read.
        notification.markAsRead();
    };
}
